<footer id="footer-common" class="footer-common bg--footer">
  <section class="row row--top">
    <div class="wrapper d-flex">
      <div class="left-side">
        <span class="footer-logo">
          <svg width="121" height="53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M52.642 48.144c0 2.387-1.952 4.333-4.347 4.333H4.367C1.952 52.477 0 50.531 0 48.144V4.353A4.356 4.356 0 014.367 0h43.928a4.352 4.352 0 014.347 4.353v43.791z"
              fill="#fff"
            />
            <path
              d="M14.952 26.279h.986c1.55 0 1.71-.903 1.71-1.425 0-.621-.201-1.424-1.71-1.424h-.986v2.849zm-3.502-5.577h5.252c3.542 0 4.548 2.447 4.548 4.152 0 1.726-1.006 4.173-4.548 4.173h-1.75v4.092H11.45V20.702zM24.61 23.67h-2.736v-2.968h8.974v2.969h-2.736v9.448H24.61v-9.448zM41.272 32.557c-1.127.763-2.294.923-3.36.923-3.703 0-6.38-2.608-6.38-6.58 0-4.152 2.938-6.56 6.319-6.56 1.107 0 2.374.282 3.42.984v3.61c-.643-.742-1.61-1.484-2.957-1.484-1.912 0-3.18 1.525-3.18 3.57 0 1.866 1.188 3.35 3.18 3.35 1.308 0 2.314-.701 2.958-1.343v3.53zM18.996 14.102h-1.288v-.401h3.1v.401h-1.309v3.25h-.503v-3.25zM24.349 15.165c-.02-.581-.443-1.203-1.188-1.203-.684 0-1.187.481-1.287 1.204h2.475zm.503 1.224c-.302.602-.825 1.103-1.69 1.103-1.228 0-1.872-.983-1.872-1.966 0-1.043.644-1.965 1.872-1.965 1.247 0 1.69 1.063 1.69 1.765v.24h-3.019c-.02.703.423 1.525 1.329 1.525.301 0 .885-.04 1.287-.902l.403.2zM25.858 13.7h.504v1.586h2.053V13.7h.503v3.65h-.503v-1.664h-2.053v1.665h-.504V13.7zM32.358 14.102h-1.349v1.725c0 .482-.12.863-.462 1.124h1.81v-2.849zm.503-.401v3.25h.523v1.324h-.463v-.923h-2.777v.923h-.483V16.95c.785-.06.845-.823.845-1.465v-1.785h2.355zM37.007 15.165c-.02-.581-.423-1.203-1.168-1.203-.684 0-1.207.481-1.308 1.204h2.476zm.503 1.224c-.302.602-.805 1.103-1.67 1.103-1.228 0-1.892-.983-1.892-1.966 0-1.043.664-1.965 1.891-1.965 1.248 0 1.67 1.063 1.67 1.765v.24h-3.018c-.02.703.443 1.525 1.348 1.525.282 0 .886-.04 1.288-.902l.383.2zM41.715 15.527c0-.723-.402-1.565-1.409-1.565-.784 0-1.307.702-1.307 1.565 0 1.023.663 1.564 1.388 1.564.825 0 1.328-.682 1.328-1.565zM38.998 13.7v.642c.222-.401.644-.782 1.369-.782 1.107 0 1.871.782 1.871 1.966 0 1.103-.704 1.965-1.851 1.965a1.58 1.58 0 01-1.348-.702v2.307h-.503v-5.396h.462z"
              fill="#E21E32"
            />
            <path
              d="M62.28 15.386v-.12c0-.622-.2-1.084-.462-1.384-.322-.361-.704-.422-1.107-.422-.422 0-.825.08-1.268.402l-.362-.562a2.863 2.863 0 011.63-.522c.664 0 1.268.18 1.75.682.685.702.765 1.605.765 2.307 0 .682-.08 1.745-.825 2.488-.563.581-1.227.662-1.77.662-.383 0-.725-.06-1.067-.2-.221-.081-.422-.201-.584-.322l.363-.602c.483.361.925.462 1.328.462.282 0 .764-.04 1.147-.401.422-.422.463-1.124.463-1.645v-.14h-2.113v-.683h2.113z"
              fill="#fff"
            />
            <path
              d="M62.28 15.386v-.06.06zm-2.696 3.27c.342.14.664.2 1.046.2.524 0 1.168-.08 1.731-.642.725-.722.805-1.785.805-2.447 0-.702-.1-1.585-.745-2.267-.483-.481-1.066-.642-1.71-.662-.443 0-.986.1-1.55.482l.302.461c.443-.3.846-.38 1.248-.38s.805.06 1.147.44c.282.301.483.803.483 1.425v.18h-2.113v.562h2.113v.2c0 .522-.04 1.244-.483 1.686-.382.38-.906.42-1.187.42-.403 0-.845-.08-1.308-.44l-.302.5c.14.101.322.202.523.282zm-.04.12c-.242-.1-.443-.22-.604-.34l-.04-.041.443-.702.04.04c.463.361.885.441 1.288.441.281 0 .744-.02 1.086-.36.403-.402.463-1.084.463-1.605v-.08h-2.113v-.803h2.113v-.06c0-.602-.18-1.063-.442-1.344-.322-.341-.685-.402-1.067-.402-.402 0-.805.08-1.227.402l-.06.04L59 13.28l.04-.02a2.909 2.909 0 011.67-.542c.664 0 1.288.18 1.811.702.684.702.765 1.645.765 2.347 0 .682-.08 1.765-.825 2.548-.604.581-1.288.662-1.832.662-.382 0-.744-.06-1.086-.2zM66.486 14.844a48.99 48.99 0 01-.18 2.207c-.061.461-.162 1.083-.564 1.444-.302.301-.644.361-.926.381l-.262.02-.14-.581.2-.06c.142-.04.343-.12.504-.261.362-.321.422-.903.483-1.525.06-.541.14-1.745.16-2.267l.061-1.323h3.039v5.957h-.825v-5.295h-1.47l-.08 1.303z"
              fill="#fff"
            />
            <path
              d="M65.822 14.202c-.02.542-.1 1.746-.16 2.267-.061.622-.122 1.224-.504 1.565-.16.16-.382.24-.523.28l-.161.04.14.482.202-.02c.282-.02.604-.08.885-.36.383-.342.483-.964.544-1.425.06-.522.14-1.485.18-2.207l.081-1.344h1.59v5.296h.704V12.94h-2.918l-.06 1.263zm-1.489 4.073l.06-.02.202-.06c.14-.04.342-.121.483-.261.322-.281.402-.843.462-1.485.06-.521.141-1.725.161-2.247l.06-1.404h3.16v6.098h-.946v-5.295h-1.368l-.06 1.243c-.04.702-.101 1.665-.182 2.207-.06.461-.16 1.103-.563 1.504-.322.301-.704.361-.986.382l-.302.04-.181-.702zM71.135 18.836V12.88h3.26l-.12.682H71.96v1.825h1.953v.662H71.96v2.086h2.516v.702h-3.34z"
              fill="#fff"
            />
            <path
              d="M71.195 18.776h3.22v-.582h-2.516v-2.206h1.932v-.542H71.9V13.5h2.314l.101-.561h-3.119v5.837zm-.06.12v-.06h.06-.06v.06h-.06v-6.078h3.38l-.12.803H72.02v1.705h1.952v.782H72.02v1.966h2.535v.822h-3.42zM80.432 13.38l-.302.06a.56.56 0 00-.302.16c-.12.1-.161.221-.181.362l-.222.742c-.06.24-.12.521-.382.762-.1.1-.221.16-.322.2v.02c.12.041.242.101.322.201.221.201.302.482.362.683l.322 1.123c.02.1.06.26.181.36.08.101.242.141.403.201l.221.08-.16.563-.423-.04c-.242-.02-.544-.08-.745-.281-.201-.181-.282-.462-.322-.723l-.221-1.043c-.04-.2-.141-.461-.282-.602-.181-.18-.423-.2-.584-.2h-.684v2.828h-.845V12.88h.845v2.447h.684c.161 0 .483 0 .685-.2.16-.161.2-.362.241-.583l.181-.762c.04-.22.1-.461.282-.642.221-.22.523-.28.684-.3l.383-.04.18.581z"
              fill="#fff"
            />
            <path
              d="M77.796 15.948c.16 0 .422.02.624.22.16.14.261.422.301.642l.222 1.044c.04.24.12.521.302.681.18.181.483.241.704.261l.382.04.121-.481-.161-.04c-.16-.06-.322-.1-.443-.22a.73.73 0 01-.18-.382l-.323-1.123c-.06-.2-.14-.462-.342-.662a.992.992 0 00-.302-.2h-.04v-.101l.02-.02c.12-.04.222-.1.322-.2.242-.222.302-.462.362-.723l.222-.742c.02-.14.06-.281.201-.381.1-.1.221-.16.342-.18l.221-.061-.14-.462-.322.06c-.161 0-.463.06-.664.262-.161.16-.222.38-.262.621l-.181.763c-.04.2-.08.42-.262.601-.221.221-.543.221-.724.221h-.745V12.94h-.724v5.837h.724v-2.828h.745zm2.575 3.009l-.442-.04c-.222-.02-.544-.08-.765-.301-.221-.2-.302-.482-.342-.742l-.221-1.044c-.04-.2-.141-.461-.262-.581-.16-.16-.382-.18-.543-.18h-.624v2.828h-.966v-6.099h.966v2.468h.624c.16 0 .463-.02.644-.18.14-.141.18-.342.221-.542l.181-.783c.04-.22.1-.461.302-.662.221-.24.563-.3.724-.32l.443-.04.161.621-.04.02.04-.02.02.06-.06.02-.282.06a.537.537 0 00-.443.462l-.22.762c-.061.24-.122.522-.403.782-.06.06-.141.12-.222.16.08.041.161.101.242.181.221.221.302.502.362.703l.322 1.123c.02.1.06.24.16.34.081.081.222.141.383.181l.262.08-.161.703-.06-.02zM85.503 13.56h-1.53v5.276h-.845v-5.275h-1.55v-.682h4.025l-.1.682z"
              fill="#fff"
            />
            <path
              d="M85.503 13.56v-.06.06zm-3.864-.06h1.55v5.276h.704V13.5h1.57l.06-.561h-3.884v.561zm1.429 5.396v-5.275h-1.55v-.803h4.146l-.1.743v.06h-1.53v5.275h-.966zM89.527 13.841c-.2-.2-.503-.3-.966-.3h-.784v2.286h.945c.403 0 .665-.1.846-.34.16-.201.261-.462.261-.803 0-.381-.1-.642-.302-.843zm.504 2.287c-.302.241-.624.361-1.248.361h-1.006v2.347h-.825V12.88h1.59c.784 0 1.106.08 1.428.26.523.321.785.823.785 1.465 0 .682-.201 1.123-.724 1.524z"
              fill="#fff"
            />
            <path
              d="M88.703 15.888h-.986V13.48h.845c.463 0 .785.1 1.006.321l-.04.04-.04.04c-.202-.18-.463-.28-.926-.28h-.725v2.166h.866c.402 0 .644-.1.825-.32.16-.201.241-.422.241-.763 0-.361-.1-.622-.282-.802l.04-.04.041-.04c.221.2.322.5.322.882 0 .361-.1.622-.262.843-.2.26-.483.36-.905.36h-.02zm-1.69 2.888h.704V16.43h1.066c.624 0 .926-.12 1.207-.34.524-.402.705-.823.705-1.485 0-.622-.262-1.103-.765-1.404-.302-.181-.604-.261-1.388-.261h-1.53v5.837zm-.121.12v-6.078h1.65c.784-.02 1.127.08 1.469.281.523.321.805.843.805 1.505.02.682-.202 1.163-.745 1.585-.302.24-.664.36-1.288.36h-.946v2.348h-.945zM94.639 13.42c-1.066 0-1.49.783-1.49 2.307 0 1.525.343 2.548 1.53 2.548.946 0 1.47-.662 1.47-2.307 0-1.605-.383-2.548-1.51-2.548zm.04 5.497c-1.65 0-2.475-1.304-2.475-3.07 0-1.965.946-3.069 2.415-3.069 1.77 0 2.455 1.465 2.455 3.13 0 1.805-.885 3.009-2.395 3.009z"
              fill="#fff"
            />
            <path
              d="M93.089 15.727c0-1.524.443-2.367 1.55-2.367v.12c-1.027 0-1.43.742-1.43 2.247 0 1.525.343 2.488 1.47 2.488.885 0 1.388-.602 1.408-2.247-.02-1.605-.362-2.488-1.449-2.488v-.12c1.188 0 1.57 1.003 1.57 2.608 0 1.645-.543 2.367-1.53 2.367-1.227 0-1.59-1.083-1.59-2.608zm-.946.12c0-1.986.986-3.129 2.475-3.129 1.811 0 2.516 1.525 2.536 3.19-.02 1.825-.926 3.069-2.496 3.069v-.12c1.49 0 2.355-1.164 2.355-2.95 0-1.644-.664-3.049-2.395-3.069-1.428.02-2.354 1.064-2.354 3.01 0 1.745.805 3.008 2.394 3.008v.12c-1.67 0-2.515-1.343-2.515-3.129zM102.205 18.836v-2.828h-2.274v2.828h-.845V12.88h.845v2.447h2.274v-2.447h.825v5.957h-.825z"
              fill="#fff"
            />
            <path
              d="M102.97 18.776V12.94h-.704v2.447h-2.415v-2.447h-.704v5.837h.704v-2.848h2.415v2.848h.704zm-.765.12v-.06h.061-.061v.06h-.06v-2.848h-2.153v2.849h-.966v-6.079h.966v2.448h2.153v-2.448h.946v6.079h-.886zM108.423 18.836v-2.828h-2.294v2.828h-.825V12.88h.825v2.447h2.294v-2.447h.825v5.957h-.825z"
              fill="#fff"
            />
            <path
              d="M109.187 18.776V12.94h-.704v2.447h-2.415v-2.447h-.704v5.837h.704v-2.848h2.415v2.848h.704zm-.764.12v-.06h.06-.06v.06h-.061v-2.848h-2.173v2.849h-.946v-6.079h.946v2.448h2.173v-2.448h.946v6.079h-.885zM113.252 13.701h-.04c-.101.341-.725 2.467-.825 2.748h1.67a73.722 73.722 0 01-.805-2.748zm1.529 5.135l-.543-1.685h-2.073l-.523 1.685h-.865l1.972-5.957h1.046l1.912 5.957h-.926z"
              fill="#fff"
            />
            <path
              d="M113.193 13.701h.02-.02zm.784 2.688a83.45 83.45 0 01-.744-2.548c-.161.522-.624 2.107-.765 2.548h1.509zm-1.69.12l.04-.08c.101-.28.725-2.427.825-2.748v-.06h.101v.08h-.02.02v-.08h.06v.06c.081.341.705 2.487.805 2.748l.04.08h-1.871zm-1.429 2.267h.745l.523-1.685h2.173l.523 1.685h.805l-1.891-5.837h-.946l-1.932 5.837zm3.924.12v-.06l.061-.02-.061.02v.06h-.06l-.523-1.684h-1.972l-.524 1.684h-1.006l2.013-6.078h1.126l1.973 6.079h-1.027zM119.35 13.54c-.261 0-.664.02-.946.301-.261.241-.281.542-.281.723 0 .22.06.521.342.742.322.22.764.24.966.24h.684v-2.005h-.765zm1.59 5.296h-.825V16.23h-.684c-.242 0-.503 0-.725.2-.201.18-.241.421-.302.602l-.181.943c-.06.2-.1.421-.282.581-.181.181-.442.261-.744.301l-.463.04-.141-.561.121-.04c.201-.06.382-.12.503-.241a.715.715 0 00.181-.401l.222-.782c.06-.261.14-.482.342-.703.181-.18.362-.26.503-.28v-.04a1.546 1.546 0 01-.805-.362c-.322-.28-.423-.622-.423-1.003 0-.581.242-.922.463-1.143.483-.441 1.127-.461 1.61-.461h1.63v5.957z"
              fill="#fff"
            />
            <path
              d="M119.431 15.607c-.222 0-.665-.02-.987-.241-.321-.24-.382-.562-.382-.803 0-.18.02-.521.302-.762.302-.3.724-.32.986-.32v.12c-.262 0-.644.02-.906.28-.241.221-.261.502-.261.682 0 .201.06.502.322.703.282.2.724.22.926.22h.623v-1.885h-.704v-.12h.825v2.126h-.744zm1.509 3.23v-.06.06zm-3.2-5.437c-.221.18-.443.522-.443 1.083 0 .361.101.702.403.963.221.18.503.301.785.341l.06.02v.12l-.06.02c-.141.02-.302.1-.483.261-.201.201-.262.422-.322.683l-.222.782c-.02.12-.08.28-.181.421-.14.14-.342.2-.543.26l-.06.02.1.462.423-.04c.282-.04.543-.12.704-.28.161-.161.201-.362.262-.562l.181-.923c.06-.2.1-.461.322-.642.221-.22.523-.22.765-.22h.744v2.607h.704V12.94h-1.569c-.483 0-1.107.02-1.57.461zm-1.227 4.875h.06l.141-.04c.181-.06.362-.12.463-.221.1-.1.141-.261.161-.381l.221-.783c.06-.26.141-.501.362-.722.121-.12.242-.2.363-.24-.242-.08-.483-.181-.665-.362-.322-.28-.442-.662-.442-1.043 0-.601.241-.963.483-1.183.503-.482 1.167-.502 1.65-.502H121v6.098h-.946V16.29h-.623c-.242 0-.483 0-.685.18-.181.16-.221.401-.281.582l-.181.923c-.061.2-.101.441-.302.642-.202.18-.483.26-.785.3l-.503.06-.181-.701zM62.32 29.227v-5.296h-2.112v5.296h-.845V23.25h3.783v5.978h-.825z"
              fill="#fff"
            />
            <path
              d="M63.086 29.167V23.31h-3.663v5.857h.725v-5.296h2.234v5.296h.704zm-.765.12v-.06h.06-.06v.06h-.08v-5.295h-1.972v5.296h-.966v-6.099h3.904v6.099h-.886zM66.667 25.215c-.04.722-.1 1.685-.18 2.207-.061.461-.162 1.103-.544 1.464-.322.301-.664.361-.946.381l-.261.02-.141-.581.201-.06c.14-.04.342-.12.503-.281.362-.301.423-.883.483-1.525.06-.521.14-1.725.161-2.247l.06-1.344h3.039v5.978h-.825v-5.296h-1.47l-.08 1.284z"
              fill="#fff"
            />
            <path
              d="M66.003 24.594c-.02.521-.1 1.725-.16 2.266-.061.622-.121 1.204-.504 1.565-.16.14-.382.22-.523.281l-.161.04.14.482.202-.02c.282-.04.604-.08.885-.362.383-.36.483-.962.544-1.424.06-.541.14-1.504.181-2.207l.08-1.343h1.59v5.295h.704V23.33h-2.917l-.06 1.264zm-1.489 4.072l.06-.02.202-.06c.14-.04.342-.12.483-.261.322-.301.402-.843.463-1.485.06-.521.14-1.725.16-2.246l.06-1.405h3.16v6.099h-.946v-5.296h-1.368l-.06 1.244c-.04.702-.1 1.665-.181 2.206-.06.462-.161 1.104-.564 1.485-.322.3-.684.38-.986.4l-.302.04-.18-.701zM73.49 23.811c-1.067 0-1.49.783-1.49 2.307 0 1.505.343 2.548 1.53 2.548.946 0 1.469-.662 1.469-2.327 0-1.585-.382-2.528-1.51-2.528zm.04 5.497c-1.65 0-2.475-1.304-2.475-3.09 0-1.945.945-3.049 2.414-3.049 1.771 0 2.456 1.465 2.456 3.11 0 1.825-.886 3.029-2.395 3.029z"
              fill="#fff"
            />
            <path
              d="M71.94 26.118c0-1.524.443-2.367 1.55-2.367v.12c-1.027 0-1.43.723-1.43 2.247 0 1.505.343 2.488 1.47 2.488.905 0 1.388-.602 1.408-2.267-.02-1.585-.362-2.468-1.449-2.468v-.12c1.188 0 1.57 1.003 1.57 2.588 0 1.665-.543 2.387-1.53 2.387-1.227 0-1.59-1.103-1.59-2.608zm-.946.1c0-1.965.986-3.109 2.475-3.109 1.811 0 2.516 1.505 2.536 3.17-.02 1.825-.926 3.089-2.475 3.089v-.12c1.469 0 2.334-1.164 2.334-2.97 0-1.644-.664-3.048-2.395-3.048-1.428 0-2.354 1.063-2.354 2.988 0 1.766.805 3.03 2.415 3.03v.12c-1.69 0-2.536-1.364-2.536-3.15zM78.782 28.545h1.75V23.25h.825v5.296h1.751V23.25h.845v5.296h.604v2.227h-.785v-1.545h-5.836V23.25h.846v5.296z"
              fill="#fff"
            />
            <path
              d="M77.997 29.167h5.836v1.545h.664v-2.106h-.604V23.31h-.724v5.296h-1.872V23.31h-.704v5.296h-1.892V23.31h-.704v5.857zm5.715 1.665v-1.544h-5.836v-6.099h.966v5.296h1.63V23.19h.946v5.296h1.63V23.19h.966v5.296h.604v2.347h-.906zM88.038 24.072h-.04c-.1.34-.725 2.487-.825 2.768h1.67c-.1-.28-.724-2.407-.805-2.768zm1.53 5.155l-.524-1.685h-2.093l-.503 1.685h-.885l1.972-5.978h1.046l1.912 5.978h-.925z"
              fill="#fff"
            />
            <path
              d="M87.978 24.092h.02-.02zm.785 2.688c-.141-.441-.604-2.026-.745-2.547-.14.521-.624 2.106-.765 2.547h1.51zm-1.69.12l.04-.08c.1-.28.744-2.427.824-2.748v-.06h.101v.06l-.02.02.02-.02v-.06h.06v.06c.08.341.705 2.468.805 2.748l.04.08h-1.87zm2.011.582l.524 1.685.805-.02-1.892-5.837h-.946l-1.912 5.837h.725l.523-1.665h2.173zm.483 1.806v-.06l.06-.02-.06.02v.06h-.04l-.543-1.685h-1.972l-.523 1.685h-1.007l2.013-6.099h1.127l1.972 6.099h-1.027zM93.753 24.674c-.04.702-.1 1.324-.322 2.166-.16.582-.342 1.123-.644 1.705h2.455v-4.614h-1.449l-.04.743zm2.334 3.871h.604v2.227h-.785v-1.545h-3.46v1.545h-.806v-2.227h.382a8.696 8.696 0 00.745-1.966c.221-.902.262-1.725.302-2.447l.02-.883h2.998v5.296z"
              fill="#fff"
            />
            <path
              d="M95.182 28.485v-4.493h-1.328l-.04.682c-.04.702-.1 1.344-.322 2.186a11.478 11.478 0 01-.604 1.625h2.294zm-2.495.12l.04-.08c.302-.581.483-1.123.644-1.685.221-.842.282-1.484.322-2.166l.04-.802h1.57v4.734h-2.616zm3.28.542v1.565h.664v-2.106h-.604V23.31H93.15l-.02.822c-.04.722-.08 1.545-.322 2.468a9.772 9.772 0 01-.725 1.965l-.02.04h-.362v2.107h.684v-1.565h3.582zm-.12 1.685v-1.544h-3.341v1.544h-.926v-2.347h.403a9.836 9.836 0 00.724-1.925c.221-.903.262-1.706.302-2.428l.02-.943h3.119v5.296h.604v2.347h-.906zM102.587 23.751l-.281.08a.497.497 0 00-.302.16.52.52 0 00-.181.342l-.222.762c-.06.24-.121.502-.382.742a.91.91 0 01-.342.221c.141.04.261.12.342.2.221.221.302.502.362.703l.322 1.123c.02.1.06.24.181.361.081.1.242.14.403.2l.221.061-.161.582-.423-.04c-.241-.02-.543-.08-.744-.281-.201-.18-.282-.462-.322-.722l-.221-1.044c-.041-.2-.141-.481-.282-.601-.181-.18-.423-.2-.584-.2h-.684v2.828h-.845V23.25h.845v2.467h.684c.161 0 .463 0 .684-.22.161-.141.202-.362.242-.562l.161-.763c.06-.24.121-.461.302-.642.221-.22.523-.28.684-.3l.382-.04.161.561z"
              fill="#fff"
            />
            <path
              d="M99.971 26.319c.161 0 .423.04.624.22.161.16.241.442.302.642l.221 1.043c.04.261.121.522.302.703.181.18.463.24.704.26l.383.04.12-.481-.161-.04c-.161-.06-.322-.1-.442-.22a.726.726 0 01-.181-.382l-.322-1.123c-.061-.22-.141-.482-.343-.662a.872.872 0 00-.322-.2l-.04-.02v-.081l.04-.02c.121-.04.222-.1.322-.2.242-.221.302-.482.363-.723l.221-.762c.02-.12.06-.261.201-.381a.816.816 0 01.322-.16l.242-.061-.141-.461-.322.04c-.161.02-.463.08-.664.28-.161.161-.222.382-.262.602l-.181.783c-.04.2-.101.42-.262.602-.241.22-.563.22-.724.22h-.745V23.31h-.724v5.857h.725V26.32h.744zm2.576 3.029l-.443-.04c-.221-.02-.543-.08-.785-.301-.201-.2-.281-.482-.322-.742l-.221-1.044c-.04-.2-.141-.46-.282-.581-.141-.16-.362-.18-.523-.18h-.624v2.828h-.966v-6.099h.966v2.468h.624c.161 0 .443-.02.644-.2.141-.141.181-.322.221-.543l.161-.762c.061-.22.121-.481.302-.662.242-.26.584-.3.745-.32l.422-.06.181.641h-.06.06l.021.06h-.061l-.282.08c-.1.02-.201.06-.281.14-.101.081-.141.202-.161.322l-.222.762c-.06.22-.12.522-.402.762-.081.08-.161.14-.221.181.08.04.161.1.221.16.241.221.322.522.382.723l.322 1.123c.02.1.061.24.161.341.081.08.222.12.383.18l.261.08-.161.703-.06-.02zM106.31 24.072h-.06c-.081.34-.705 2.487-.825 2.768h1.69a66.58 66.58 0 01-.805-2.768zm1.529 5.155l-.543-1.685h-2.073l-.523 1.685h-.865l1.972-5.978h1.026l1.932 5.978h-.926z"
              fill="#fff"
            />
            <path
              d="M107.034 26.78c-.14-.441-.603-2.026-.744-2.547-.161.521-.624 2.106-.765 2.547h1.509zm-1.69.12l.04-.08c.101-.28.725-2.427.805-2.748l.02-.06h.101v.06l-.02.02.02-.02v-.06h.04l.02.06c.081.341.705 2.468.805 2.748l.041.08h-1.872zm2.012.582l.524 1.685.805-.02-1.892-5.837h-.946l-1.932 5.837h.745l.523-1.665h2.173zm.483 1.806v-.06l.061-.02-.061.02v.06h-.06l-.523-1.685h-1.992l-.503 1.685h-1.007l1.993-6.099h1.147l1.952 6.099h-1.007zM61.938 34.603c-.2-.2-.503-.28-.965-.28h-.765v2.266h.926c.402 0 .664-.1.865-.34.16-.201.241-.442.241-.783 0-.381-.1-.662-.302-.863zm.504 2.307c-.302.221-.624.362-1.248.362h-.986v2.327h-.845V33.64h1.61c.764 0 1.086.08 1.408.28.523.321.805.823.805 1.445 0 .682-.201 1.123-.744 1.544z"
              fill="#fff"
            />
            <path
              d="M61.134 36.65h-.986v-2.388h.825c.483 0 .785.1 1.026.301l-.06.04-.04.06c-.181-.2-.463-.28-.926-.28h-.704v2.146h.865c.402 0 .624-.08.805-.32.16-.181.241-.422.241-.743 0-.381-.08-.642-.281-.802l.04-.06.06-.04c.201.2.302.5.302.902 0 .361-.08.602-.262.822-.2.261-.483.362-.885.362h-.02zm-1.71 2.888h.724v-2.327h1.046c.624 0 .926-.12 1.228-.36.503-.402.704-.823.704-1.485 0-.602-.282-1.084-.765-1.385-.322-.2-.623-.28-1.388-.28h-1.55v5.837zm-.121.14V33.58h1.67c.765 0 1.127.08 1.449.281.523.341.825.863.825 1.505 0 .702-.221 1.163-.765 1.584-.302.241-.644.381-1.288.381h-.925v2.348h-.966zM67.07 34.202c-1.086 0-1.509.783-1.509 2.287 0 1.525.362 2.568 1.55 2.568.925 0 1.448-.662 1.448-2.327 0-1.605-.362-2.528-1.489-2.528zm.02 5.497c-1.65 0-2.475-1.304-2.475-3.09 0-1.945.966-3.049 2.435-3.049 1.75 0 2.455 1.465 2.455 3.11 0 1.805-.905 3.029-2.415 3.029z"
              fill="#fff"
            />
            <path
              d="M65.5 36.49c0-1.505.443-2.348 1.57-2.348v.12c-1.047 0-1.45.723-1.45 2.227 0 1.525.343 2.488 1.49 2.508.885-.02 1.388-.622 1.388-2.267 0-1.605-.362-2.467-1.428-2.467v-.12c1.167 0 1.55.982 1.55 2.587 0 1.665-.544 2.387-1.51 2.387-1.248 0-1.61-1.103-1.61-2.628zm-.946.12c0-1.966.986-3.11 2.495-3.11 1.811 0 2.516 1.505 2.516 3.17 0 1.825-.926 3.089-2.475 3.089v-.12c1.469-.02 2.334-1.184 2.354-2.97-.02-1.644-.684-3.048-2.395-3.048-1.428 0-2.354 1.063-2.374 2.988.02 1.766.805 3.01 2.415 3.03v.12c-1.69 0-2.536-1.364-2.536-3.15zM73.75 39.699c-.784 0-1.408-.321-1.85-.903-.423-.542-.645-1.264-.645-2.106 0-.682.121-1.284.383-1.766.442-.842 1.227-1.364 2.153-1.364.563 0 1.087.16 1.469.462l-.403.561a1.733 1.733 0 00-1.066-.34c-.584 0-1.046.3-1.328.842-.181.381-.282.883-.282 1.605 0 .622.08 1.003.221 1.364.282.642.825.963 1.47.963.442 0 .764-.12 1.086-.382l.403.562a2.74 2.74 0 01-1.61.502z"
              fill="#fff"
            />
            <path
              d="M71.839 38.836c-.423-.561-.664-1.284-.664-2.146 0-.702.14-1.304.402-1.786.463-.882 1.268-1.404 2.214-1.404.583 0 1.107.16 1.509.482l.04.04-.483.642-.04-.04c-.322-.241-.644-.321-1.026-.321-.564 0-.986.28-1.268.802-.181.381-.282.883-.282 1.585 0 .622.08 1.003.222 1.344.261.622.785.923 1.408.923.443 0 .745-.12 1.047-.361l.06-.04.483.661-.06.04a2.866 2.866 0 01-1.65.502v-.12c.583 0 1.086-.16 1.529-.462l-.322-.441c-.322.22-.644.34-1.087.34-.664 0-1.247-.32-1.53-1.002-.14-.361-.22-.762-.22-1.384 0-.722.1-1.244.301-1.625.282-.582.765-.903 1.369-.903.382 0 .724.1 1.046.321l.342-.441c-.362-.281-.865-.421-1.388-.421-.906 0-1.67.501-2.093 1.324-.262.481-.382 1.063-.382 1.745 0 .842.221 1.544.623 2.066.443.562 1.047.862 1.812.883v.12a2.387 2.387 0 01-1.912-.923zM79.487 39.699c-.765 0-1.41-.321-1.852-.903-.422-.542-.644-1.264-.644-2.106 0-.682.141-1.284.383-1.766.442-.842 1.227-1.364 2.153-1.364.563 0 1.086.16 1.469.462l-.403.561a1.716 1.716 0 00-1.046-.34c-.604 0-1.067.3-1.328.842-.201.381-.302.883-.302 1.605 0 .622.08 1.003.221 1.364.282.642.825.963 1.47.963.442 0 .764-.12 1.086-.382l.422.562a2.802 2.802 0 01-1.63.502z"
              fill="#fff"
            />
            <path
              d="M77.594 38.836c-.442-.561-.664-1.284-.664-2.146 0-.702.141-1.304.382-1.786.463-.882 1.268-1.404 2.214-1.404.584 0 1.127.16 1.51.482l.04.04-.483.642-.04-.04a1.583 1.583 0 00-1.007-.321c-.583 0-1.006.28-1.288.802-.18.381-.281.883-.281 1.585 0 .622.08 1.003.22 1.344.263.622.786.923 1.41.923.442 0 .744-.12 1.046-.361l.06-.04.483.661-.06.04a2.866 2.866 0 01-1.65.502v-.12c.583 0 1.087-.16 1.53-.462l-.323-.441c-.322.22-.644.34-1.087.34-.663 0-1.247-.32-1.529-1.002-.14-.361-.221-.762-.221-1.384 0-.722.1-1.244.302-1.625.281-.582.764-.903 1.388-.903.362 0 .704.1 1.026.321l.343-.441c-.363-.281-.866-.421-1.389-.421-.885 0-1.67.501-2.093 1.324-.241.481-.382 1.063-.382 1.745 0 .842.221 1.544.624 2.066.442.562 1.046.862 1.81.883v.12c-.784 0-1.428-.341-1.89-.923zM86.328 39.599v-3.832c0-.3.02-.903.04-1.164-.06.181-.161.522-.282.723l-2.233 4.273h-.866V33.64h.825v3.891c0 .281-.02.702-.06 1.043.1-.28.242-.642.362-.882l2.093-4.052h.946v5.958h-.825z"
              fill="#fff"
            />
            <path
              d="M87.092 39.538v-5.837h-.845l-2.073 4.012c-.12.24-.281.602-.362.882l-.12-.04c.04-.32.06-.742.06-1.023v-3.831h-.704v5.837h.764l2.234-4.232c.1-.201.221-.522.261-.723l.121.02c-.02.261-.04.863-.04 1.164v3.771h.704zm-.764.14v-.08h.06-.06v.08h-.06v-3.911c0-.18 0-.462.02-.722-.041.12-.101.22-.142.32l-2.253 4.314h-.966V33.58h.945v3.952c0 .16 0 .381-.02.582.06-.16.141-.321.222-.461l2.093-4.073h1.046v6.099h-.885zM92.767 39.599v-3.832c0-.3.02-.903.04-1.164-.04.181-.16.522-.281.723l-2.234 4.273h-.865V33.64h.825v3.891c0 .281-.02.702-.06 1.043.1-.28.24-.642.362-.882l2.092-4.052h.946v5.958h-.825z"
              fill="#fff"
            />
            <path
              d="M93.532 39.538v-5.837h-.846l-2.072 4.012c-.12.24-.282.602-.362.882l-.121-.04c.04-.32.06-.742.06-1.023v-3.831h-.704v5.837h.765l2.233-4.232c.1-.201.222-.522.262-.723l.12.02c-.02.261-.04.863-.04 1.164v3.771h.705zm-.765.14v-.08h.06-.06v.08h-.06v-3.911c0-.18 0-.462.02-.722-.04.12-.1.22-.141.32l-2.254 4.314h-.966V33.58h.946v3.952c0 .16 0 .381-.02.582.08-.16.14-.321.221-.461l2.113-4.073h1.026v6.099h-.885z"
              fill="#fff"
            />
          </svg>
        </span>
        <nav class="nav-common">
          <ul class="nav-list">
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/contacts"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Контакты</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/news"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Новости</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/smi"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>СМИ о нас</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/rukovodstvo"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Руководство</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/client-reviews"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Отзывы клиентов</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/history"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>История</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/partners"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Партнеры</span></a
              >
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/about/vacancy"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Вакансии</span></a
              >
            </li>
          </ul>
        </nav>
        <nav class="nav-helper">
          <ul class="nav-list">
            <li class="item">
              <span class="link">Удаленная техподдержка</span>
              <div class="ammyy-anydesk-support-block">
                <a
                  href="https://www.rts-tender.ru/Portals/0/Files/RTS-tender_anydesk.exe"
                  id="anydeskLink"
                >
                  <img src="assets/icons/svg/anydesk-icon.svg" alt="anydesk" />
                </a>
                <a href="http://www.ammyy.com/ru/" target="_blank" id="ammyyLink">
                  <img src="assets/icons/svg/ammyy-icon.svg" alt="ammyy" />
                </a>
              </div>
            </li>
            <li class="item">
              <a
                class="link"
                href="https://www.rts-tender.ru/rts-tender.ru.exe"
                data-ui-logger-operation="FooterGotoContacts"
                data-ui-logger-comment="callback: getCurrentUrl"
                data-ui-logger-delay=""
                ><span>Программное обеспечение</span></a
              >
            </li>
          </ul>
        </nav>
        <button type="button" class="btn btn-helper" (click)="supportModalWindowOpen()">
          Написать в поддержку
        </button>
      </div>
      <div class="right-side">
        <div class="platform-list">
          <nav class="nav nav-44-fz">
            <h4 class="txt-header">44-ФЗ</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-44/participant-44"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Поставщикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-44/customers-44"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Заказчикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-44-tariffs"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/platform-rules/platform-44"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Документы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/legislation"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Законодательство</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://app.rts-tender.ru/supplier/lk/Participant/SpecialAccountApplication.aspx#/SpecialAccounts/Application/View"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Специальный счет</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <p class="tel txt-tel">8 800 77-55-800</p>
              </li>
            </ul>
          </nav>
          <nav class="nav nav-223-fz">
            <h4 class="txt-header">223-ФЗ</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-223/participants-223"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Поставщикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-223/customers-223"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Заказчикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-223-tariffs"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/platform-rules/platform-223"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Регламент</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/details/platform-223-details"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Реквизиты</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://app.rts-tender.ru/supplier/lk/Participant/SpecialAccountApplication.aspx#/SpecialAccounts/Application/View"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Специальный счет</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <a class="support-tel-number">8 499 653-9-900</a>
              </li>
            </ul>
          </nav>
          <nav class="nav nav-commercial-purchases">
            <h4 class="txt-header">Коммерческие<br />закупки</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/corp/participants-corp"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Поставщикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/corp/customers-corp"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Заказчикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-223-tariffs"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/platform-rules/platform-223"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Регламент</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/details/platform-223-details"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Реквизиты</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <a class="support-tel-number">8 499 653-9-900</a>
              </li>
            </ul>
          </nav>
          <nav class="nav nav-615-ppRF">
            <h4 class="txt-header">615-ПП РФ</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-615/participants-615"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Поставщикам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/zakupki-615/customers-615"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Заказчикам/ОВР</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-615-tariffs"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/platform-rules/platform-223"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Регламент</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/details/platform-223-details"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Реквизиты</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://223.rts-tender.ru/customer/lk/Deal615Registry"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>ЕРД</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <a class="support-tel-number">8 499 653-9-900</a>
              </li>
            </ul>
          </nav>
          <nav class="nav nav-property">
            <h4 class="txt-header">Имущество</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/property-sales/property-buyers"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Покупателям</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/property-sales/property-sailers"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Продавцам</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-property-sales-tariffs"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/platform-rules/platform-property-sales"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Регламент</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/details/platform-property-sales-details"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Реквизиты</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <a class="support-tel-number">8 499 653-77-00</a>
              </li>
            </ul>
          </nav>
          <nav class="nav nav-rts-market">
            <h4 class="txt-header">РТС-Маркет</h4>
            <ul class="nav-platform">
              <li class="d-column item">
                <a
                  class="link"
                  href="https://market.rts-tender.ru/product/create"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Разместить товар в каталоге</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://market.rts-tender.ru/zapros/create"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Опубликовать объявление о покупке</span></a
                >
              </li>
              <li class="d-column item">
                <a
                  class="link"
                  href="https://www.rts-tender.ru/tariffs/platform-market"
                  data-ui-logger-operation="FooterGotoContacts"
                  data-ui-logger-comment="callback: getCurrentUrl"
                  data-ui-logger-delay=""
                  ><span>Тарифы</span></a
                >
              </li>
            </ul>
            <ul class="nav-support">
              <li>
                <p class="txt-support">Техподдержка</p>
                <a class="support-tel-number">8 800 775-99-59</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </section>

  <section class="row border--top">
    <div class="wrapper">
      <p class="rts-text cookie-banner__text">
        ООО «РТС–тендер»
        <a
          class="footer__cookie-link"
          href="https://www.rts-tender.ru/cookies_pollicy"
          target="_blank"
          rel="noopener noreferrer"
        >
          использует файлы cookie </a
        >, с целью персонализации сервисов и повышения удобства пользования веб-сайтом. «Cookie»
        представляют собой небольшие файлы, содержащие информацию о предыдущих посещениях веб-сайта.
        Продолжая использовать наш сайт, вы соглашаетесь, что мы можем использовать файлы cookie.
        Если вы не хотите использовать файлы «cookie», измените настройки браузера.
      </p>
    </div>
  </section>

  <section class="row row--bottom border--top">
    <div class="wrapper">
      <nav class="nav-connection">
        <ul class="nav-connection-container">
          <li class="social__container left-side">
            <a
              class="link"
              href="https://t.me/rtstenderinfo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0V0Z"
                  fill="white"
                />
                <path
                  d="M23.9598 8.8L20.963 24.1008C20.963 24.1008 20.8342 24.8 19.967 24.8C19.5062 24.8 19.2686 24.5808 19.2686 24.5808L12.7774 19.1944L9.60141 17.5936L5.5254 16.5096C5.5254 16.5096 4.7998 16.3 4.7998 15.7C4.7998 15.2 5.5462 14.9616 5.5462 14.9616L22.599 8.1872C22.5982 8.1864 23.1198 7.9992 23.4998 8C23.7334 8 23.9998 8.1 23.9998 8.4C23.9998 8.6 23.9598 8.8 23.9598 8.8Z"
                  fill="#343846"
                />
                <path
                  d="M15.2003 21.2046L12.4595 23.9038C12.4595 23.9038 12.3403 23.9958 12.1811 23.9998C12.1259 24.0014 12.0667 23.9926 12.0059 23.9654L12.7771 19.1934L15.2003 21.2046Z"
                  fill="#343846"
                />
                <path
                  d="M20.7172 11.3569C20.582 11.1809 20.3324 11.1489 20.1564 11.2825L9.59961 17.6001C9.59961 17.6001 11.2844 22.3137 11.5412 23.1297C11.7988 23.9465 12.0052 23.9657 12.0052 23.9657L12.7764 19.1937L20.642 11.9169C20.818 11.7833 20.8508 11.5329 20.7172 11.3569Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              class="link"
              href="https://vk.com/rtstender"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M32.2393 16.0083C32.2393 24.8495 25.0721 32.0166 16.231 32.0166C7.38982 32.0166 0.222656 24.8495 0.222656 16.0083C0.222656 7.16716 7.38982 0 16.231 0C25.0721 0 32.2393 7.16716 32.2393 16.0083ZM16.8826 23.0296H15.6261C15.6261 23.0296 12.8538 23.1965 10.4126 20.6548C7.75011 17.8825 5.39872 12.3813 5.39872 12.3813C5.39872 12.3813 5.26317 12.0206 5.41042 11.8462C5.57593 11.6502 6.0268 11.6376 6.0268 11.6376L9.03025 11.6179C9.03025 11.6179 9.31333 11.6653 9.51594 11.814C9.68288 11.9367 9.77648 12.1661 9.77648 12.1661C9.77648 12.1661 10.2619 13.3937 10.9048 14.5044C12.1595 16.6726 12.744 17.1468 13.17 16.9146C13.7907 16.5758 13.6046 13.8495 13.6046 13.8495C13.6046 13.8495 13.616 12.8598 13.2922 12.4192C13.0413 12.0776 12.5682 11.9781 12.3593 11.9501C12.1904 11.9275 12.4677 11.5352 12.8273 11.3591C13.3678 11.0943 14.3223 11.0792 15.4501 11.0909C16.3287 11.0997 16.5815 11.1545 16.9251 11.2375C17.7222 11.43 17.6974 12.0467 17.6437 13.3774C17.6277 13.775 17.6091 14.2364 17.6091 14.7692C17.6091 14.8891 17.6056 15.0169 17.602 15.1483C17.5834 15.8298 17.5621 16.6101 18.0106 16.9C18.2406 17.0484 18.8034 16.9223 20.2108 14.5323C20.878 13.3997 21.3782 12.0679 21.3782 12.0679C21.3782 12.0679 21.4875 11.8305 21.6573 11.7286C21.8311 11.6248 22.0654 11.6567 22.0654 11.6567L25.226 11.637C25.226 11.637 26.1757 11.5238 26.3295 11.9524C26.4908 12.4024 25.9746 13.4531 24.6833 15.1741C23.457 16.8086 22.8611 17.4093 22.9172 17.9414C22.958 18.3293 23.3453 18.6807 24.0874 19.3695C25.6432 20.8136 26.0579 21.5719 26.1564 21.7521C26.1644 21.7667 26.1703 21.7775 26.1746 21.7846C26.8709 22.9391 25.4024 23.0296 25.4024 23.0296L22.5953 23.0687C22.5953 23.0687 21.992 23.1883 21.1981 22.6429C20.783 22.358 20.3771 21.8927 19.9903 21.4493C19.3992 20.7715 18.8528 20.1451 18.3865 20.293C17.604 20.5412 17.6285 22.2272 17.6285 22.2272C17.6285 22.2272 17.6342 22.5873 17.4559 22.7791C17.2621 22.9879 16.8826 23.0296 16.8826 23.0296Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              class="link"
              href="https://www.youtube.com/channel/UCvA114k2xebV4FaaEQaQg1A"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0ZM24.1768 12.0488C23.9805 11.2948 23.4022 10.701 22.6679 10.4995C21.3371 10.1333 16.0001 10.1333 16.0001 10.1333C16.0001 10.1333 10.6632 10.1333 9.3323 10.4995C8.59795 10.701 8.01962 11.2948 7.82335 12.0488C7.4668 13.4153 7.4668 16.2666 7.4668 16.2666C7.4668 16.2666 7.4668 19.1178 7.82335 20.4845C8.01962 21.2385 8.59795 21.8322 9.3323 22.0338C10.6632 22.4 16.0001 22.4 16.0001 22.4C16.0001 22.4 21.3371 22.4 22.6679 22.0338C23.4022 21.8322 23.9805 21.2385 24.1768 20.4845C24.5335 19.1178 24.5335 16.2666 24.5335 16.2666C24.5335 16.2666 24.5335 13.4153 24.1768 12.0488ZM14.4004 19.2V13.8667L18.6671 16.5335L14.4004 19.2Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li class="technical__container ml--auto">
            <div class="copyright__container">
              <span class="tech-info">
                &copy; 2000-{{ getFullYear() }} ООО «РТС-тендер».<br />Все права защищены.
              </span>
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <div class="support-modal-block">
      <p-dialog
        [showHeader]="false"
        [visible]="isSupportModalWindowVisible"
        minY="600"
        modal="true"
        baseZIndex="1000000"
        [resizable]="false"
        width="550"
        [styleClass]="'support-modal-window'"
      >
        <div class="support-modal-window__header">
          <h3>Написать в техподдержку</h3>
          <span (click)="supportModalWindowClose()" class="ico ico--close">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.66406 8L16 14.3317V16H14.3254L8 9.66934L1.66406 16H0V14.3317L6.32539 8L0 1.66719V0H1.66406L8 6.33174L14.3254 0H16V1.66719L9.66406 8Z"
                fill="#858585"
              />
            </svg>
          </span>
        </div>
        <p-accordion
          [styleClass]="'support-modal-accordion'"
          [expandIcon]="'pi pi-chevron-down'"
          [collapseIcon]="'pi pi-chevron-up'"
        >
          <p-accordionTab header="44-ФЗ" [selected]="false">
            <a
              class="test"
              href="https://www.rts-tender.ru/zakupki-44/participant-44"
              rel="noopener noreferrer"
              >Поставщикам/Участникам</a
            >
            <a href="https://www.rts-tender.ru/zakupki-44/customers-44" rel="noopener noreferrer"
              >Заказчикам</a
            >
          </p-accordionTab>
          <p-accordionTab header="223-ФЗ" [selected]="false">
            <a
              href="https://www.rts-tender.ru/zakupki-223/participants-223"
              rel="noopener noreferrer"
              >Поставщикам/Участникам</a
            >
            <a href="https://www.rts-tender.ru/zakupki-223/customers-223" rel="noopener noreferrer"
              >Заказчикам</a
            >
          </p-accordionTab>
          <p-accordionTab header="Коммерческие закупки" [selected]="false">
            <a href="https://www.rts-tender.ru/corp/participants-corp" rel="noopener noreferrer"
              >Поставщикам/Участникам</a
            >
            <a href="https://www.rts-tender.ru/corp/customers-corp" rel="noopener noreferrer"
              >Заказчикам</a
            >
          </p-accordionTab>
          <p-accordionTab header="615-ПП РФ" [selected]="false">
            <a
              href="https://www.rts-tender.ru/zakupki-615/participants-615"
              rel="noopener noreferrer"
              >Поставщикам/Участникам</a
            >
            <a href="https://www.rts-tender.ru/zakupki-615/customers-615" rel="noopener noreferrer"
              >ОВР/Заказчикам</a
            >
          </p-accordionTab>
          <p-accordionTab header="Имущество" [selected]="false">
            <a
              href="https://www.rts-tender.ru/property-sales/property-buyers"
              rel="noopener noreferrer"
              >Покупателям/Арендаторам</a
            >
            <a
              href="https://www.rts-tender.ru/property-sales/property-sailers"
              rel="noopener noreferrer"
              >Продавцам/Арендодателям</a
            >
          </p-accordionTab>
          <div class="support-rts-market">
            <a href="mailto:market@rts-tender.ru" rel="noopener noreferrer">РТС-Маркет</a>
          </div>
        </p-accordion>
      </p-dialog>
    </div>
  </section>
</footer>
